import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

// Import your images
import img0 from "../image/reavanue.png";
import img1 from "../image/trust.png";
import img2 from "../image/cost.png";
import img3 from "../image/digital.png";
import img4 from "../image/notifaction.png";
import img5 from "../image/reputaction.png";
import img6 from "../image/globel.png";
import img7 from "../image/sequrees.webp";
import img8 from "../image/multiuser.png";
import img9 from "../image/loyalty.png";
import img10 from "../image/boots.png";
import img11 from "../image/installment.png";



const DigitalMenuSection = ({ setShowLogin, setIsSignup, isLoggedIn }) => {
  const sections = [
    {
      title: "Trusted Digital Presence, Wider Reach",
      desc: "Customers trust what they see online. A professional digital presence immediately improves credibility and decision-making.With Maamaas, your business gets a complete digital storefront that showcases:No need for website development, app building, designers, or technical knowledge.Everything is ready to use from Day 1.Maamaas makes every local business capable of competing with large brands — without heavy investment.",
      img: img1,
       features:[
  "Book services and order food in one app",
  "Plan events and travel",
  "Access multiple lifestyle services seamlessly",
  "Your brand identity and business information",
  "Product or service menus, pricing, and photos",
  "Real-time updates, offers, and announcements",
  "Customer reviews & direct communication",
  "A professional digital business profile",
  "Online visibility to reach more customers",
  "Instant messaging & direct engagement",
  "Improved trust and stronger brand identity",
  "More conversions and higher revenue"
],
    },
    {
      title: "our Revenue, Your Rules",
      desc: "Many online platforms charge 15–30% commission on every order, forcing businesses to increase prices and reducing actual profit.Maamaas follows a business-friendly model with zero commission.At Maamaas, your hard work is rewarded — not charged.",
      img: img0,
      features: [
  "You keep 100% profit from every sale",
  "No deduction, no hidden charges, no penalty",
  "Stable earnings that support real growth",
  "More earnings from every customer",
  "More budget to improve quality and operations",
  "Ability to offer better pricing and discounts",
],

    },
    {
      title: "Clear, Easy, Cost-Effective",
      desc: "Instead of commission loss, Maamaas offers a simple yearly subscription plan.No complicated charges. No fluctuating costs. One small yearly subscription for complete control.",
      img: img2,
      features: [
  "Complete digital storefront",
  "Order, booking & customer management",
  "Billing, payments & financial tracking tools",
  "Reviews, ratings & promotional features",
  "Analytics & performance insights",
  "Multi-user access for your business team",
],

    },
    {
      title: "Digital Billing. Live Payments.",
      desc: "Step into the future of business management with seamless digital billing. No more handwritten bills, missing records, or calculation mistakes.With Maamaas:",
      img: img3,
      features: [
  "Generate professional invoices instantly",
  "Auto-record every transaction safely in the cloud",
  "Maintain error-free financial history",
  "Export reports anytime for GST filing, audits, or accounts",
  "Track payments received / pending / cancelled",
],

result:
  "Save time, reduce errors, and operate with complete transparency",




    },
    {
      title: "Instant Order Alerts",
      desc: "Stay connected to every customer moment — get instant alerts for orders, bookings, and inquiries whether you're online or offline, so no opportunity is ever missed.",
      img: img4,
      features: [
  "New customer orders",
  "Bookings & reservations",
  "Customer support inquiries",
  "Payment updates & status changes",
],
result:
  "Faster response, zero delays, increased customer satisfaction.",

    },
    {
      title: "Real Reviews, Real Reputation",
      desc: "Let your work speak for itself — positive customer reviews build trust, boost visibility, and strengthen your business reputation so more people choose you with confidence.",
      img: img5,
      features: [
  "Honest reviews from real customers",
  "High ratings boost your ranking in search results",
  "Improves repeat customers & referrals",
  "Builds strong digital identity & credibility",
],
result:
  "People choose businesses they trust — reviews make the difference.",

    },
    {
      title: "Business Analytics & Growth Insights",
      desc: "Make smarter business decisions with confidence — real-time insights and data analytics help you understand customer behavior, track performance, and plan the next move with clarity.",
      img: img6,
      features: [
  "Track sales daily, weekly, monthly",
  "Understand customer buying behaviour",
  "Identify best-selling items or services",
  "Know peak hours and demand seasons",
],
result:
  "Smarter strategies, better planning, and higher profits.",

    },
    {
      title: "Flexible & Secure Payment Options",
      desc: "Offer customers complete payment flexibility — whether via UPI, cards, wallets, or net banking, transactions are fast, secure, and hassle-free every time..",
      img: img7,
      features: [
  "UPI / Cards / Wallets / Net Banking / COD",
  "Instant payment confirmation",
  "Zero payment confusion or disputes",
],
result:
  "Faster payments = Faster business growth.",

    },
    {
      title: "Multi-User Access for Teams",
      desc: "Streamline staff management with digital tools — assign tasks, monitor performance, and stay in full control, all from one easy-to-use platform..",
      img: img8,
      features: [
  "👥 Add team members with role-based permissions",
  "🔒 Control access for security",
  "📝 Track logins, activities, and updates",
],
result:
  "Perfect for restaurants, retail stores, salons, and service centers.",


    },
    {
      title: "Customer Loyalty & Promotional Tools",
      desc: "Boost customer loyalty by providing seamless experiences and personalized engagement, encouraging them to return again and again.",
      img: img9,
      features: [
  "🎁 Reward points & membership benefits",
  "🎉 Festival and seasonal promotions",
  "🏷 Coupons, discounts & offer codes",
  "📣 Boost engagement & increase lifetime customer value",
],
result:
  "Enhance customer loyalty and maximize repeat business.",


    },
    {
      title: "Marketing & Local Discovery Boost",
      desc: "Get noticed and stay ahead of the competition — Maamaas increases your business visibility online, helping you reach more customers without extra marketing costs.",
      img: img10,
      features: [
  "🚀 Featured placement in app listings",
  "📍 Local area promotion",
  "🖼 Banner promotion & branding space",
],
result:
  "Free digital marketing support that drives real customer reach.",




    },
    {
      title: "No Hardware & Zero Installation",
      desc: "Manage your entire business seamlessly from any device — access orders, bookings, payments, and customer data anytime, anywhere, keeping you in control on the go.",
      img: img11,
      features: [
  "📱 Smartphone",
  "💻 Laptop",
  "📟 Tablet or POS system",
],
result:
  "No servers, cables, maintenance, or IT installation required.",



    },
  ];

  

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [expandedFeatures, setExpandedFeatures] = useState(
    Array(sections.length).fill(false)
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleFeature = (index) => {
    const updated = [...expandedFeatures];
    updated[index] = !updated[index];
    setExpandedFeatures(updated);
  };

  const openSignup = () => {
    setShowLogin(true);
    setIsSignup(true);
  };

  return (
    <div style={styles.container}>
      {/* MAIN HEADER */}
      <div style={styles.header}>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{ position: "relative", display: "inline-block" }}
        >
          <p style={styles.mainHeading}>
            Digital Presence That Builds  <span style={styles.highlight}>Trust & Expands Reach</span>
          </p>
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: "70%" }}
            transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
            style={{
              height: "2px",
              background: "#9e48d3",
              borderRadius: "4px",
              marginTop: "6px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
        </motion.div>
        
      </div>

      {/* SECTIONS */}
      <div style={styles.sectionsWrapper}>
        {sections.map((section, index) => (
          <motion.div
            key={index}
            initial={{ x: index % 2 === 0 ? -50 : 50, opacity: 0, scale: 0.95 }}
            whileInView={{ x: 0, opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, ease: "easeOut", delay: index * 0.1 }}
            viewport={{ once: true, margin: "-50px" }}
            style={{
              ...styles.sectionContainer,
              marginBottom: index === sections.length - 1 ? "0" : "20px",
              flexDirection: isMobile ? "column" : index % 2 === 0 ? "row" : "row-reverse",
            }}
          >
            {/* IMAGE */}
            <div style={styles.imageWrapper}>
              <div style={styles.imageFrame}>
                <img src={section.img} alt={section.title} style={styles.sectionImage} loading="lazy" />
                <div
                  style={{
                    ...styles.imageDecoration,
                    
                  }}
                />
              </div>
            </div>

            {/* CONTENT */}
            <div style={styles.contentWrapper}>
              <div style={styles.contentInner}>
                <div style={styles.titleRow}>
                  <div
                    style={{
                      ...styles.titleIcon,
                      background:
                        index % 2 === 0
                          ? "linear-gradient(135deg, #b15cd6 0%, #6a11cb 100%)"
                          : "linear-gradient(135deg, #6a11cb 0%, #b15cd6 100%)",
                    }}
                  >
                    <span style={styles.iconText}>{index + 1}</span>
                  </div>
                  <h2 style={styles.sectionTitle}>{section.title}</h2>
                </div>

                <p style={styles.sectionDescription}>{section.desc}</p>

                {/* BUTTONS */}
                <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginTop: "auto" }}>
                  {!isLoggedIn && (
                    <button
                      style={{
                        ...styles.signupBtn,
                        background:
                          index % 2 === 0
                            ? "linear-gradient(135deg, #b15cd6 0%, #6a11cb 100%)"
                            : "linear-gradient(135deg, #6a11cb 0%, #b15cd6 100%)",
                        padding: isMobile ? "8px 14px" : "12px 22px",
                        fontSize: isMobile ? "13px" : "16px",
                        borderRadius: isMobile ? "6px" : "10px",
                      }}
                      onClick={openSignup}
                    >
                      Sign Up <span style={styles.arrowBlink}>➜</span>
                    </button>
                  )}

                  {/* KEY FEATURE BUTTON */}
                  <button
                    style={{
                      ...styles.signupBtn,
                      background: "linear-gradient(135deg, #ff7a18 0%, #af002d 100%)",
                      padding: isMobile ? "8px 14px" : "12px 22px",
                      fontSize: isMobile ? "13px" : "16px",
                      borderRadius: isMobile ? "6px" : "10px",
                    }}
                    onClick={() => toggleFeature(index)}
                  >
                    Key Features
                  </button>
                </div>

                {/* EXPANDED FEATURES */}
                {expandedFeatures[index] && (
  <>
    <ul style={styles.featureList}>
      {section.features.map((feat, i) => (
        <li key={i} style={styles.featureItem}>
          {feat}
        </li>
      ))}
    </ul>

    {section.result && (
      <p style={styles.resultText}>
        <strong>Benefits:</strong> {section.result}
        
      </p>
    )}
  </>
)}

                
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    minHeight: "100vh",
    // backgroundColor: "#faf9ff",
    padding: "60px 5%",
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    position: "relative",
    overflow: "hidden",
  },
  header: { textAlign: "center", marginBottom: "32px", marginTop: "-57px", padding: "0 20px" },
  mainHeading: { fontSize: "clamp(2.7rem, 5vw, 2.7rem)", fontWeight: "800", color: "#222", marginBottom: "20px", letterSpacing: "-1px", lineHeight: "1.1" },
  highlight: { background: "linear-gradient(135deg, #b15cd6 0%, #6a11cb 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" },
  subHeading: { fontSize: "clamp(1.1rem, 2vw, 1.3rem)", color: "#666", maxWidth: "1200px", margin: "0 auto", lineHeight: "1.6", fontWeight: "400", opacity: 0.9 },
  sectionsWrapper: { maxWidth: "1400px", margin: "0 auto", padding: "20px 0" },
  sectionContainer: { display: "flex", alignItems: "center", gap: "0px", width: "100%", minHeight: "400px", position: "relative" },
  imageWrapper: { flex: "1", minWidth: "0", position: "relative" },
  imageFrame: { position: "relative", height: "400px", overflow: "hidden", borderRadius: "25px" },
  sectionImage: { width: "100%", height: "100%", objectFit: "contain", transition: "transform 0.6s ease" },
  imageDecoration: { position: "absolute", top: "20px", left: "20px", right: "-20px", bottom: "-20px", borderRadius: "25px", opacity: 0.1, zIndex: -1, filter: "blur(10px)" },
  contentWrapper: { flex: "1", minWidth: "0" },
  contentInner: {
  padding: "40px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  position: "relative", // <-- add this
},
  titleRow: { display: "flex", alignItems: "center", gap: "20px", marginBottom: "25px" },
  titleIcon: { width: "50px", height: "50px", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxShadow: "0 8px 20px rgba(177, 92, 214, 0.2)" },
  iconText: { color: "white", fontSize: "1.5rem", fontWeight: "700" },
  sectionTitle: { fontSize: "clamp(1.8rem, 2.5vw, 2.2rem)", fontWeight: "800", color: "#222", margin: 0, letterSpacing: "-0.5px", lineHeight: "1.2" },
  sectionDescription: { fontSize: "1.05rem", lineHeight: "1.8", color: "#555", marginBottom: "35px", flex: 1, fontWeight: "400" },
  signupBtn: { border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: "12px", transition: "transform 0.3s ease", boxShadow: "0px 8px 15px rgba(0,0,0,0.15)" },
  arrowBlink: { fontSize: "24px", fontWeight: "700", color: "#fff", animation: "arrowBlink 0.8s infinite alternate ease-in-out" },
  featureList: { marginTop: "15px", paddingLeft: "20px" },
  featureItem: { marginBottom: "6px", fontSize: "1rem", color: "#333", lineHeight: "1.5" },
};

export default DigitalMenuSection;
